/**
 * @desc 打印标签
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(aono: string | number, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/labelPrint/${aono}`, {
      method: "GET",

      ...options,
    }),
  );
}
